import { render, staticRenderFns } from "./generalInfo.vue?vue&type=template&id=6786b65a&scoped=true&"
import script from "./generalInfo.vue?vue&type=script&lang=js&"
export * from "./generalInfo.vue?vue&type=script&lang=js&"
import style0 from "./particulars.css?vue&type=style&index=0&id=6786b65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786b65a",
  null
  
)

export default component.exports